import { Configuration } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId:
      process.env.REACT_APP_CLIENT_ID || "22d08baa-a74f-4f2f-b812-cdd7806f3387",
    authority:
      process.env.REACT_APP_AUTHORITY_SIGN_IN ||
      "https://kundesystemdev.b2clogin.com/kundesystemdev.onmicrosoft.com/B2C_1_signin",
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "/",
    knownAuthorities: [
      process.env.REACT_APP_KNOW_AUTHORITY || "kundesystemdev.b2clogin.com",
    ],
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URI || "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [
    process.env.REACT_APP_LOGIN_SCOPE ||
      "https://kundesystemdev.onmicrosoft.com/kundesystem/webapi",
  ],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me",
};
